import React, { Component } from "react";
import Main from "./pages/Main";
import Login from "./pages/Login";
import * as GlobalFunc from "./utils/globalFunc";
import * as Http from "./http";
import SmartAlert from "./pages/Main/SmartAlert";
import * as Business from "./utils/business";
import Loading from "./components/Loading";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = { isLogin: true, isLoading: false };

    GlobalFunc.setFuncLogout(this.logout);
    GlobalFunc.setDownloadSampleFuc(this.downloadSample);
  }

  downloadSample = () => {
    return;
  };

  logout = () => {
    this.setState({ isLogin: true });
    Http.logout();
  };

  onLogin = (value) => {
    this.setState({
      isLoading: true,
    });
    return Http.loginWithLdap(value.text, value.password).then((isSuccess) => {
      if (isSuccess) {
        Http.queryRoleGroup(true).then(() =>
          this.setState({
            isLogin: false,
            isLoading: false,
          }),
        );
        return { success: true };
      } else {
        Business.showAlert({
          title: "Error",
          content: "Login failed",
        });
        this.setState({
          isLoading: false,
        });
        return { success: false };
      }
    });
  };

  renderLoading = () => {
    const screenSize = Business.getSizeScreen();
    return (
      <Loading
        width={screenSize.width}
        height={screenSize.height}
        size="small"
      />
    );
  };

  render() {
    return (
      <div>
        {this.state.isLoading ? (
          this.renderLoading()
        ) : this.state.isLogin ? (
          <Login onLogin={this.onLogin} />
        ) : (
          <Main />
        )}
        <SmartAlert />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/App.js